import React from 'react'
import { Trans } from '@lingui/macro'

import { AccountTabSection } from '../TabContentSection'
import { ScimConfig } from './ScimConfig'

export const ProvisioningTab: React.FC = () => {
  return (
    <AccountTabSection>
      <div className="AccountPage__box">
        <h4>
          SCIM <Trans>Integration</Trans>
        </h4>
        <p className="text-description">
          <Trans>
            Continuously update your users in Looop with data from Okta, Azure
            or any other SCIM compatible source
          </Trans>
        </p>
        <ScimConfig />
      </div>
    </AccountTabSection>
  )
}
